import React from 'react';
import Notification from './Notification.js';
import { useNotificationToasts } from './NotificationContext.js';
import './NotificationStack.css';

/**
 * NotificationStack renders all active notifications in bottom-left corner
 */
const NotificationStack = () => {
  const { notifications, removeNotification } = useNotificationToasts();

  if (notifications.length === 0) {
    return null;
  }

  return (
    <div className="notification-stack">
      {notifications.map((notification) => (
        <Notification
          key={notification.timestamp}
          notification={notification}
          onRemove={removeNotification}
        />
      ))}
    </div>
  );
};

export default NotificationStack;
